import { render } from "./CustomShape.vue?vue&type=template&id=749f00c9&scoped=true"
import script from "./CustomShape.vue?vue&type=script&lang=js"
export * from "./CustomShape.vue?vue&type=script&lang=js"

import "./CustomShape.vue?vue&type=style&index=0&id=749f00c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749f00c9"]])

export default __exports__